import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useDocument } from "../../firebase-files/hooks/useDocument.js";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext.js";
import { useFirestore } from "../../firebase-files/hooks/useFirestore.js";
import { useCollection } from "../../firebase-files/hooks/useCollection.js";
import { useNavigate } from "react-router-dom";
import {
  projectFirestore,
  projectStorage,
} from "../../firebase-config/config.js";
import CorporateTwoClients from "../../templates/corporate/corporateTwo/corporateTwoComponents/CorporateTwoClients/CorporateTwoClients.jsx";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Autocomplete from "@mui/material/Autocomplete";
import { useRef } from "react";
import Popup from "../../default-components/Popup.js";
import ReactSwitch from "react-switch";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import TextEditor from "../../default-components/TextEditor.jsx";
import useWishlist from "../../firebase-files/hooks/useWishlist.js";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import OwlCarousel from "react-owl-carousel";
import { SketchPicker } from "react-color";
import Modal from "@mui/material/Modal";
import MuiAlert from "@mui/material/Alert";
import { Snackbar } from "@mui/material";
import {
  MDBCol,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardBody,
  MDBTypography,
} from "mdb-react-ui-kit";
import { Tabs, Tab, Box, TextField, Button } from "@mui/material";
import ReactImageMagnify from "react-image-magnify";
import { FaEdit } from "react-icons/fa";
import Gallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./ProductDetails.css";
import useCart from "../../firebase-files/hooks/useCart.js";

const labels = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

function getLabelText(rating) {
  return `${rating} Star${rating !== 1 ? "s" : ""}, ${labels[rating]}`;
}
const ProductDetails = () => {
  // Scroll to the top of the page whenever the location changes start
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const navigate = useNavigate();

  // Start firebase code
  const { user } = useAuthContext();

  const { productId } = useParams();

  const { document: appTypeDocument } = useDocument("settings", "AppType");
  const { document: TAXDocument } = useDocument("settings", "tax_GST");

  const { document: productDetailsVisibility } = useDocument(
    "settings",
    "productDetailsVisibility"
  );

  const { document: functionTypeDocument } = useDocument(
    "settings",
    "FunctionType"
  );

  const { updateDocument } = useFirestore("products");

  const { deleteDocument } = useFirestore("products");

  const { documents: allproducts } = useCollection("products");

  const { document, error } = useDocument("products", productId);

  const { document: currencyDocument } = useDocument("settings", "currency");

  const { documents: allcategories } = useCollection("m_categories");

  const { document: pageControlDoc } = useDocument("settings", "pagesControl");

  const { document: qrCodeData } = useDocument("pages-data", "paymentDetails");

  const { updateDocument: updateQrCodeDocument } = useFirestore("pages-data");

  // End Firebase code

  // copy product functionality state
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [copyProductForm, setCopyProductForm] = useState({
    name: "",
    price: "",
    discount: "",
  });

  // Add this state at the top with other states
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [open, setOpen] = useState(false);

  // Add this useEffect to fetch related products
  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (document) {
        try {
          let productsToFetch = new Set();

          // If this is a copy, fetch the original
          if (document.originalProductId) {
            productsToFetch.add(document.originalProductId);
          }

          // Get IDs of all copies from either original or the original of this copy
          const originalId = document.originalProductId || document.id;
          const originalDoc = document.originalProductId
            ? await projectFirestore
                .collection("products")
                .doc(document.originalProductId)
                .get()
            : { exists: true, data: () => document };

          if (originalDoc.exists) {
            const originalData = document.originalProductId
              ? originalDoc.data()
              : document;
            if (originalData.relatedCopies) {
              originalData.relatedCopies.forEach((copy) =>
                productsToFetch.add(copy.productId)
              );
            }
          }

          // Fetch all products
          const fetchedProducts = await Promise.all(
            Array.from(productsToFetch).map(async (id) => {
              const doc = await projectFirestore
                .collection("products")
                .doc(id)
                .get();
              if (doc.exists) {
                return { id: doc.id, ...doc.data() };
              }
              return null;
            })
          );

          // Filter out nulls and set related products
          const validProducts = fetchedProducts.filter((p) => p !== null);
          setRelatedProducts([document, ...validProducts]);
        } catch (error) {
          console.error("Error fetching related products:", error);
          setRelatedProducts([document]);
        }
      }
    };

    fetchRelatedProducts();
  }, [document]);

  // quantity functionality

  const [isQuantityModalOpen, setIsQuantityModalOpen] = useState(false);
  const [quantityForm, setQuantityForm] = useState({
    maxQuantity: "",
    minQuantity: "",
    stock: "",
  });

  useEffect(() => {
    if (document) {
      setQuantityForm({
        maxQuantity: document.maxQuantity || "",
        minQuantity: document.minQuantity || "",
        stock: document.stock || "",
      });
    }
  }, [document]);

  const handleQuantityFormChange = (e) => {
    const { name, value } = e.target;
    setQuantityForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Add this handler to save quantity settings
  const handleSaveQuantity = async () => {
    try {
      await updateDocument(productId, {
        maxQuantity: parseInt(quantityForm.maxQuantity),
        minQuantity: parseInt(quantityForm.minQuantity),
        stock: parseInt(quantityForm.stock),
      });
      setIsQuantityModalOpen(false);
      setSnackbarMessage("Quantity settings updated successfully");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating quantity settings:", error);
      setSnackbarMessage("Error updating quantity settings");
      setSnackbarOpen(true);
    }
  };

  // delete popup

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

  const fileInputRef = useRef(null);
  const [checked, setChecked] = useState();
  const [editedName, setEditedName] = useState("");
  const [productName, setProductName] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedBrand, setEditedBrand] = useState("");
  const [isEditingBrand, setIsEditingBrand] = useState(false);
  const [editedModel, setEditedModel] = useState("");
  const [isEditingModel, setIsEditingModel] = useState(false);
  const [editedSku, setEditedSku] = useState("");
  const [isEditingSku, setIsEditingSku] = useState(false);
  const [editedHsn, setEditedHsn] = useState("");
  const [isEditingHsn, setIsEditingHsn] = useState(false);
  const [editedPrice, setEditedPrice] = useState("");
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [productPrice, setProductPrice] = useState("");
  const [priceType, setPriceType] = useState(
    (document && document.priceType) || "Fixed"
  );
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [isEditingFeatures, setIsEditingFeatures] = useState(false);
  const [editedFeatures, setEditedFeatures] = useState("");
  const [productFeatures, setProductFeatures] = useState("");
  const [isEditingRating, setIsEditingRating] = useState(false);
  const [editedRating, setEditedRating] = useState("");
  const [productDiscount, setProductDiscount] = useState("");
  const [isEditingDiscount, setIsEditingDiscount] = useState(false);
  const [editedDiscount, setEditedDiscount] = useState("");
  const [AddOption, setAddOption] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selctedOption, setOptions] = useState([]);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [isAddOption, setIsAddOption] = useState(false);
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [editedShortDescription, setEditedShortDescription] = useState("");
  const [productShortDescription, setProductShortDescription] = useState("");
  const [isEditingShortDescription, setIsEditingShortDescription] =
    useState(false);
  const [imageDescription, setImageDescription] = useState("");
  const [isLocationPopupOpen, setIsLocationPopupOpen] = useState(false);
  const [locationLink, setLocationLink] = useState(
    document?.productLocation || ""
  );
  const [selectedTab, setSelectedTab] = useState("features");
  const [productImages, setProductImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [rating, setRating] = useState(2);
  const [editedExternalUrl, setEditedExternalUrl] = useState("");
  const [isEditingProductUrl, setIsEditingExternalUrl] = useState(false);
  const [productExternalUrl, setProductExternalUrl] = useState("");
  const [checkedTopSelling, setCheckedTopSelling] = useState(false);
  const [checkedPopular, setCheckedPopular] = useState(false);
  const [checkedNewArrivals, setCheckedNewArrivals] = useState(false);
  const [isShippingAllow, setIsShippingAllow] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for snackbar
  const [snackbarMessage, setSnackbarMessage] = useState(""); // State for snackbar message
  const [bookingCount, setBookingCount] = useState("0+");
  const [isEditingBookingCount, setIsEditingBookingCount] = useState(false);
  const [editedBookingCount, setEditedBookingCount] = useState("");
  // Units Sold Counter State
  const [unitsSold, setUnitsSold] = useState(null); // null means not set
  const [isEditingUnitsSold, setIsEditingUnitsSold] = useState(false);
  const [editedUnitsSold, setEditedUnitsSold] = useState("");
  const [productGST, setProductGST] = useState("");
  const [productSGST, setProductSGST] = useState("");
  const [productCGST, setProductCGST] = useState("");
  const [productCESS, setProductCESS] = useState("");
  // use cart hook destructuring && Cart functionality
  const { addToCart } = useCart();
  const [productCategory, setProductCategory] = useState({
    category: [], // now an array
    subCategory: [],
  });

  const [isQrPopupOpen, setIsQrPopupOpen] = useState(false);
  const [imageFile, setImageFile] = useState(null); // To store the file for upload
  const [isQrUploading, setIsQrUploading] = useState(false); // New state to track upload status
  const [uploadError, setUploadError] = useState(null); // State for upload error message
  const [isEditingUpiId, setIsEditingUpiId] = useState(false);
  const [upiId, setUpiId] = useState(qrCodeData && qrCodeData.upiId); // Initial state with qrCodeData if available

  // Add these functions with your other state handlers (around line 340)
  const handleColorVisibilityToggle = async () => {
    const newVisibility = !isColorVisible;
    setIsColorVisible(newVisibility);
    try {
      await updateDocument(productId, { showColors: newVisibility });
    } catch (error) {
      console.error("Error updating color visibility:", error);
    }
  };

  const handleSizeVisibilityToggle = async () => {
    const newVisibility = !isSizeVisible;
    setIsSizeVisible(newVisibility);
    try {
      await updateDocument(productId, { showSizes: newVisibility });
    } catch (error) {
      console.error("Error updating size visibility:", error);
    }
  };

  const handleVariantVisibilityToggle = async () => {
    const newVisibility = !isVariantVisible;
    setIsVariantVisible(newVisibility);
    try {
      await updateDocument(productId, { showVariants: newVisibility });
    } catch (error) {
      console.error("Error updating variant visibility:", error);
    }
  };
  const handleCatInputChange = (event, selectedCategories) => {
    const selectedCategoryNames = selectedCategories.map((cat) => cat.category);

    // Collect all active subcategories from selected categories
    const selectedSubcategories = selectedCategories.flatMap(
      (cat) => cat.subCategories?.filter((sub) => sub.status === "active") || []
    );

    setProductCategory((prev) => ({
      ...prev,
      category: selectedCategoryNames,
      subCategory: [], // Reset subcategories, user must select manually again
    }));
  };

  const handleSubCategoryChange = (event, selectedSubCategories) => {
    const selectedSubCategoryNames = selectedSubCategories.map(
      (sub) => sub.subCategoryName
    );

    setProductCategory((prev) => ({
      ...prev,
      subCategory: selectedSubCategoryNames,
    }));
  };

  const handleAddToCart = async (productId) => {
    if (!user) {
      // if user is not logged in → redirect to login
      // THIS CODE BASICALLY IF USER LOGIN SO CAME BACK ON EXISTING PAGE
      navigate("/login", { state: { from: location } });
      return;
    }
    await addToCart(productId);

    setSnackbarMessage("Item added to Cart"); // Set message
    setSnackbarOpen(true);
  };
  const [isColorVisible, setIsColorVisible] = useState(false);
  const [isSizeVisible, setIsSizeVisible] = useState(false);
  const [isVariantVisible, setIsVariantVisible] = useState(false);

  // colors functionality
  const [isColorModalOpen, setIsColorModalOpen] = useState(false);
  const [selectedInputColor, setSelectedInputColor] = useState("#ffffff");
  const [colorName, setColorName] = useState("");
  const [selectedColor, setSelectedColor] = useState(null);
  const [colorUrl, setColorUrl] = useState(""); // New state for color URL

  // Update handleSelectedColor to handle URL navigation
  const handleSelectedColor = (color) => {
    if (color.colorUrl) {
      const trimmedUrl = color.colorUrl.trim();

      if (!trimmedUrl) {
        setSelectedColor(color);
        return;
      }

      const appBaseUrl = window.location.origin;

      try {
        const url = new URL(trimmedUrl, appBaseUrl);
        const isInternal = url.origin === appBaseUrl;

        if (isInternal) {
          const relativePath = url.pathname + url.search + url.hash;
          navigate(relativePath, { replace: false });
        } else {
          setSnackbarMessage("Navigating to external site...");
          setSnackbarOpen(true);
          window.location.assign(trimmedUrl);
        }
      } catch (error) {
        console.error("Invalid URL:", trimmedUrl, error);
        setSnackbarMessage("Invalid URL provided");
        setSnackbarOpen(true);
        setSelectedColor(color);
      }
    } else {
      setSelectedColor(color);
    }
  };

  // function to open color modal
  const handleOpenColorModal = () => {
    setIsColorModalOpen(true);
  };

  const handleOpenSizeModal = () => {
    setIsSizeModalOpen(true);
  };

  const handleCloseSizeModal = () => {
    setIsSizeModalOpen(false);
    setSize("");
    setSizeUrl("");
  };

  // Function to close the color modal
  const handleCloseColorModal = () => {
    setIsColorModalOpen(false);
    setSelectedInputColor("#ffffff");
  };

  // Function to handle color change in the color picker
  const handleColorChange = (color) => {
    setSelectedInputColor(color.hex);
  };
  const handleSaveBookingCount = async () => {
    try {
      await updateDocument(productId, {
        bookingCount: editedBookingCount,
      });
      setBookingCount(editedBookingCount);
      setIsEditingBookingCount(false);
      setSnackbarMessage("Booking count updated");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating booking count:", error);
      setSnackbarMessage("Error updating booking count");
      setSnackbarOpen(true);
    }
  };
  const handleSaveUnitsSold = async () => {
    try {
      const valueToSave = editedUnitsSold.trim();

      await updateDocument(productId, {
        unitsSold: valueToSave || "0", // Save as "0" if empty
      });

      setUnitsSold(valueToSave || null);
      setIsEditingUnitsSold(false);
      setSnackbarMessage("Units sold updated");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating units sold:", error);
    }
  };

  const handleSaveColor = async () => {
    const colorToBeSaved = {
      color: selectedInputColor,
      colorName,
      colorUrl: colorUrl.trim() || "", // Add URL to color object
    };
    try {
      const updatedColors = document.colors
        ? [...document.colors, colorToBeSaved]
        : [colorToBeSaved];
      await updateDocument(productId, { colors: updatedColors });
      setColorName("");
      setColorUrl(""); // Reset URL field
      handleCloseColorModal();
    } catch (error) {
      console.error("Error saving color:", error);
    }
  };

  // Function to delete a color
  const handleDeleteColor = async (colorToDelete) => {
    try {
      const updatedColors = document.colors.filter(
        (color) => color !== colorToDelete
      );
      await updateDocument(productId, { colors: updatedColors });
    } catch (error) {
      console.error("Error deleting color:", error);
    }
  };

  //function to delete image confimation

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    imageToDelete: null,
    imageIndex: null,
  });

  // size functionality
  const [size, setSize] = useState("");
  const [isSizeModalOpen, setIsSizeModalOpen] = useState(false);

  const [selectedSize, setSelectedSize] = useState(null);
  const [sizeUrl, setSizeUrl] = useState(""); // New state for size URL

  const handleSelectedSize = (sizeObj) => {
    if (sizeObj.sizeUrl) {
      const trimmedUrl = sizeObj.sizeUrl.trim();

      if (!trimmedUrl) {
        setSelectedSize(sizeObj);
        return;
      }

      const appBaseUrl = window.location.origin;

      try {
        const url = new URL(trimmedUrl, appBaseUrl);
        const isInternal = url.origin === appBaseUrl;

        if (isInternal) {
          const relativePath = url.pathname + url.search + url.hash;
          navigate(relativePath, { replace: false });
        } else {
          setSnackbarMessage("Navigating to external site...");
          setSnackbarOpen(true);
          window.location.assign(trimmedUrl);
        }
      } catch (error) {
        console.error("Invalid URL:", trimmedUrl, error);
        setSnackbarMessage("Invalid URL provided");
        setSnackbarOpen(true);
        setSelectedSize(sizeObj);
      }
    } else {
      setSelectedSize(sizeObj);
    }
  };

  const handleSaveSize = async () => {
    try {
      const newSize = {
        size,
        sizeUrl: sizeUrl.trim() || "",
      };
      const updatedSizes = document.sizes
        ? [...document.sizes, newSize]
        : [newSize];
      await updateDocument(productId, { sizes: updatedSizes });
      handleCloseSizeModal();
    } catch (error) {
      console.error("Error adding size:", error);
    }
  };

  const handleDeleteSize = async (sizeToDelete) => {
    try {
      const updatedSizes = document.sizes.filter((size, index) => {
        return size !== sizeToDelete;
      });
      await updateDocument(productId, { sizes: updatedSizes });
    } catch (err) {
      console.log("Error deleting size:", err);
    }
  };

  // variants functionality
  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
  const [variantInfo, setVariantInfo] = useState({
    variantName: "",
    variantPrice: "",
    variantUrl: "",
  });
  const [selectedVariant, setSelectedVariant] = useState(null);

  const handleVariantClick = (variant) => {
    if (variant.variantUrl) {
      const trimmedUrl = variant.variantUrl.trim();
      // Skip if URL is empty
      if (!trimmedUrl) {
        setSelectedVariant(variant);
        return;
      }
      // Get the app's base URL (replace with your app's domain)
      const appBaseUrl = window.location.origin; // e.g., "https://yourapp.com"

      try {
        // Parse the URL
        const url = new URL(trimmedUrl, appBaseUrl); // Handles both relative and absolute URLs
        const isInternal = url.origin === appBaseUrl; // Check if URL is within your app

        if (isInternal) {
          // Extract the pathname for client-side navigation
          const relativePath = url.pathname + url.search + url.hash;
          navigate(relativePath, { replace: false }); // Client-side navigation, no reload
        } else {
          // For external URLs, open in same tab (will reload, but warn user if needed)
          setSnackbarMessage("Navigating to external site...");
          setSnackbarOpen(true);
          window.location.assign(trimmedUrl); // Fallback for external URLs
        }
      } catch (error) {
        console.error("Invalid URL:", trimmedUrl, error);
        setSnackbarMessage("Invalid URL provided");
        setSnackbarOpen(true);
        setSelectedVariant(variant); // Fallback to selecting variant
      }
    } else {
      setSelectedVariant(variant);
    }
  };

  const handleVariantModalOpen = () => {
    setIsVariantModalOpen(true);
  };

  const handleVariantModalClose = () => {
    setIsVariantModalOpen(false);
  };
  const handleVariantChange = (e) => {
    const { name, value } = e.target;
    setVariantInfo({ ...variantInfo, [name]: value });
  };

  // Update variant save handler
  const handleSaveVariant = async () => {
    try {
      const newVariant = document.variants
        ? [
            ...document.variants,
            {
              variantName: variantInfo.variantName,
              variantPrice: variantInfo.variantPrice,
              variantUrl: variantInfo.variantUrl,
            },
          ]
        : [
            {
              variantName: variantInfo.variantName,
              variantPrice: variantInfo.variantPrice,
              variantUrl: variantInfo.variantUrl,
            },
          ];

      await updateDocument(productId, { variants: newVariant });
      setVariantInfo({ variantName: "", variantPrice: "", variantUrl: "" });
      handleVariantModalClose();
    } catch (err) {
      console.log("Error adding new Variant:", err);
    }
  };

  const handleDeleteVariant = async (variantToDelete) => {
    try {
      const updatedVariants = document.variants.filter((variant, index) => {
        return variant !== variantToDelete;
      });
      await updateDocument(productId, { variants: updatedVariants });
    } catch (err) {
      console.log("Error deleting variant:", err);
    }
  };

  const [selectedVariantPrice, setSelectedVariantPrice] = useState(null);
  const [discountedPrice, setDiscountedPrice] = useState(null);

  // Add this useEffect to handle URL changes
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const variantId = searchParams.get("variant");
    if (variantId) {
      const selected = document.variants.find((v) => v.id === variantId);
      if (selected) setSelectedVariant(selected);
    }
  }, [document?.variants]);

  useEffect(() => {
    if (selectedVariant?.id) {
      navigate(`?variant=${selectedVariant.id}`, { replace: true });
    }
  }, [selectedVariant]);

  useEffect(() => {
    if (selectedVariant) {
      setSelectedVariantPrice(selectedVariant.variantPrice);
      setDiscountedPrice(
        Math.ceil(
          selectedVariant.variantPrice -
            selectedVariant.variantPrice *
              (document.discount.split("%")[0] / 100)
        )
      );
    }
  }, [selectedVariant]);

  // START CHANGE CAT FUNCTIONALITY
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);

  const handleCategoryModalOpen = () => {
    setIsCategoryModalOpen(true);
  };

  const handleCategoryModalClose = () => {
    setIsCategoryModalOpen(false);
    setProductCategory([]);
  };

  useEffect(() => {
    // Fetch document data and set editedName
    if (document && TAXDocument) {
      setProductName(document.name);
      setEditedName(document.name);
      setEditedBrand(document.brand || ""); // Add this line
      setEditedModel(document.model || ""); // Add this line
      setEditedSku(document.sku || "");
      setEditedHsn(document.hsn || "");
      setProductPrice(document.price);
      setEditedPrice(document.price);
      setPriceType(document.priceType);
      setProductDescription(document.description);
      setEditedDescription(document.description);
      setProductShortDescription(document.short_description);
      setEditedShortDescription(document.short_description);
      setProductDiscount(document.discount);
      setEditedDiscount(document.discount);
      setProductExternalUrl(document.external_url);
      setEditedExternalUrl(document.external_url);
      setProductFeatures(document.features);
      setEditedFeatures(document.features);
      setIsColorVisible(document.showColors || false);
      setIsSizeVisible(document.showSizes || false);
      setIsVariantVisible(document.showVariants || false);
      setBookingCount(document.bookingCount || "0+");
      setEditedBookingCount(document.bookingCount || "0+");
      setUnitsSold(document.unitsSold || null);
      setEditedUnitsSold(document.unitsSold || "");
      const taxData = {
        gst: document.gst || TAXDocument.gst || "",
        sgst: document.sgst || TAXDocument.sgst || "",
        cgst: document.cgst || TAXDocument.cgst || "",
        cess: document.cess || TAXDocument.cess || "",
      };

      setProductGST(taxData.gst);
      setProductSGST(taxData.sgst);
      setProductCGST(taxData.cgst);
      setProductCESS(taxData.cess);
      // setOriginalTaxData(taxData);
    }
  }, [document, TAXDocument]);

  // START CODE FOR WISHLIST CLICK AND STORE IN BROWSER STORAGE
  // hook for wishlist
  const { wishlistItems, addToWishlist, removeFromWishlist } = useWishlist();

  const findWishlistItem = (productId) => {
    return wishlistItems.find((item) => item.productId === productId);
  };

  const handleAddToWishlist = (productId) => {
    addToWishlist(productId);
    setSnackbarMessage("Added to Wishlist"); // Set message
    setSnackbarOpen(true); // Open snackbar
  };

  const handleWishlistRemove = (wishlistItem) => {
    // ✅ Firestore ke doc ka id dena hoga
    removeFromWishlist(wishlistItem.id);
    setSnackbarMessage("Removed from Wishlist"); // Set message
    setSnackbarOpen(true); // Open snackbar
  };

  const isProductInWishlist = (productId) => {
    return wishlistItems?.some((item) => item.productId === productId) || false;
  };

  const handleDeleteImage = async () => {
    try {
      const { imageToDelete } = deleteConfirmation;

      // Filter out the image to be deleted
      const updatedImages = (document.images || []).filter((img) => {
        if (typeof img === "string") {
          return img !== imageToDelete;
        } else if (typeof img === "object" && img.url) {
          return img.url !== imageToDelete;
        }
        return true;
      });

      // Update Firestore document
      await updateDocument(productId, { images: updatedImages });

      setSnackbarMessage("Image deleted successfully");
      setSnackbarOpen(true);
      setDeleteConfirmation({
        isOpen: false,
        imageToDelete: null,
        imageIndex: null,
      });
    } catch (error) {
      console.error("Error deleting image:", error);
      setSnackbarMessage("Error deleting image");
      setSnackbarOpen(true);
      setDeleteConfirmation({
        isOpen: false,
        imageToDelete: null,
        imageIndex: null,
      });
    }
  };

  const openDeleteConfirmation = (imageUrl, imageIndex) => {
    setDeleteConfirmation({
      isOpen: true,
      imageToDelete: imageUrl,
      imageIndex,
    });
  };
  // snack bar functionality

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false); // Close snackbar
  };
  //END CODE FOR HEART CLICK AND STORE IN BROWSER STORAGE

  if (error) {
    return (
      <div className="error" style={{ marginTop: "100px" }}>
        Data Not Found
      </div>
    );
  }
  if (!document) {
    return <div className="loading"></div>;
  }

  // START CODE FOR ADD NEW IMAGES

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setIsConfirmVisible(true);
    }
  };

  // 2. Modify the handleConfirmUpload function

  const handleConfirmUpload = async () => {
    if (selectedImage) {
      setIsUploading(true);
      try {
        const file = fileInputRef.current.files[0];
        const storageRef = projectStorage.ref(
          `product_img/${productId}/${file.name}`
        );
        await storageRef.put(file);

        const downloadURL = await storageRef.getDownloadURL();

        // Create image object with URL and description
        const newImage = {
          url: downloadURL,
          createdAt: new Date(),
          description: imageDescription || "", // Use empty string if no description
        };

        const updatedImages = [...(document.images || []), newImage];

        await projectFirestore
          .collection("products")
          .doc(productId)
          .update({ images: updatedImages });
        setProductImages(updatedImages);

        setSelectedImage(null);
        setImageDescription(""); // Reset description
        setIsConfirmVisible(false);
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setIsUploading(false);
      }
    }
  };

  const handleCancelUpload = () => {
    setSelectedImage(null);
    setImageDescription(""); // Reset description
    setIsConfirmVisible(false);
    setIsUploading(false);
  };

  const images = document.images || [];

  // START CODE FOR EDIT FIELDS
  const handleEditClick = (fieldName) => {
    switch (fieldName) {
      case "name":
        setIsEditingName(true);
        break;
      case "rating":
        setIsEditingRating(true);
        break;
      case "price":
        setIsEditingPrice(true);
        break;
      case "discount":
        setIsEditingDiscount(true);
        break;
      case "shortdescription":
        setIsEditingShortDescription(true);
        break;
      case "producturl":
        setIsEditingExternalUrl(true);
        break;
      case "description":
        setIsEditingDescription(true);
        break;
      case "features":
        setIsEditingFeatures(true);
        break;
      default:
        break;
    }
  };

  // Function to handle saving the edited field
  const handleSaveClick = async (fieldName) => {
    try {
      switch (fieldName) {
        case "price":
          // Convert to number and validate
          const priceValue = parseFloat(editedPrice);
          if (isNaN(priceValue) || priceValue < 0) {
            setSnackbarMessage("Please enter a valid price");
            setSnackbarOpen(true);
            return;
          }
          await updateDocument(productId, {
            price: priceValue,
            priceType: priceType,
          });
          setIsEditingPrice(false);
          break;

        case "name":
          await updateDocument(productId, { name: editedName }); // Update the name in Firestore
          setIsEditingName(false); // Close the editing mode
          break;
        case "category":
          // Collect selected categories and subcategories as arrays
          const selectedCategories = productCategory.category; // array of category strings
          const selectedSubCategories = productCategory.subCategory; // array of subcategory strings

          // Optional: fallback in case arrays are empty
          const finalCategories = selectedCategories.length
            ? selectedCategories
            : [];
          const finalSubCategories = selectedSubCategories.length
            ? selectedSubCategories
            : [];

          await updateDocument(productId, {
            category: finalCategories, // Save category array
            subCategory: finalSubCategories, // Save subCategory array
          });

          setIsCategoryModalOpen(false);
          break;
        case "price":
          await updateDocument(productId, {
            price: editedPrice,
            priceType: priceType,
          });
          setIsEditingPrice(false);
          break;
        case "discount":
          await updateDocument(productId, { discount: editedDiscount });
          setIsEditingDiscount(false);
          break;
        case "shortdescription":
          await updateDocument(productId, {
            short_description: editedShortDescription,
          });
          setIsEditingShortDescription(false);
          break;
        case "externalurl":
          setIsEditingExternalUrl(false);
          break;
        case "description":
          setIsEditingDescription(false);
          break;
        case "features":
          setIsEditingFeatures(false);
          break;
        default:
          break;
        case "gst":
          await updateDocument(productId, {
            gst: productGST,
            sgst: productSGST,
            cgst: productCGST,
            cess: productCESS,
          });
          setSnackbarMessage("TAX updated successfully");
          setSnackbarOpen(true);
          break;
      }
    } catch (error) {
      console.error("Error updating field:", error);
    }
  };

  const handleCancelClick = (fieldName) => {
    switch (fieldName) {
      case "name":
        setEditedName(document.name);
        setIsEditingName(false);
        break;
      case "rating":
        setEditedRating(document.rating);
        setIsEditingRating(false);
        break;
      case "price":
        setEditedPrice(document.price);
        setIsEditingPrice(false);
        break;
      case "discount":
        setEditedDiscount(document.discount);
        setIsEditingDiscount(false);
        break;
      case "shortdescription":
        setEditedShortDescription(document.short_description);
        setIsEditingShortDescription(false);
        break;
      case "externalurl":
        setEditedExternalUrl(document.external_url);
        setIsEditingExternalUrl(false);
        break;
      case "description":
        setEditedDescription(document.description);
        setIsEditingDescription(false);
        break;
      case "features":
        setEditedFeatures(document.features);
        setIsEditingFeatures(false);
        break;
      // Add more cases for other fields if needed
      default:
        break;
    }
  };
  // END CODE FOR EDIT FIELDS

  // START CODE FOR SHARE SERVICE
  const shareURL = async () => {
    try {
      await navigator.share({
        title: "Share this service",
        text: "Check out this service!",
        url: window.location.href,
      });
    } catch (error) {
      console.error("Sharing failed:", error);
    }
  };
  // END CODE FOR SHARE PRODUCT

  // START CODE FOR CHANGE PRODUCT STATUS
  const handleStatusToggleChange = (productId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    // Update the status using updateDocument hook
    updateDocument(productId, { status: newStatus })
      .then(() => {
        setChecked(newStatus === "active");
      })
      .catch((error) => {
        console.error("Error updating product status:", error);
      });
  };
  // END CODE FOR CHANGE PRODUCT STATUS

  // delete document code
  const handleDeleteProduct = async () => {
    try {
      // Open the delete confirmation popup
      setIsDeletePopupOpen(true);
    } catch (error) {
      console.error("Error deleting service:", error);
      // Handle the error as needed
    }
  };

  const handleConfirmDeleteProduct = async () => {
    try {
      await deleteDocument(productId);
      // Redirect to the services page
      window.location.href = "/services";
    } catch (error) {
      console.error("Error deleting service:", error);
      // Handle the error as needed
    }
  };

  // START CODE FOR CATEGORY OPTIONS
  const handleAddOptionClick = () => {
    setIsAddOption(true);
  };
  const handleSaveAddOption = async () => {
    try {
      // Get the current options array from the document
      const currentOptions = document.options || [];

      // Add the new option to the array
      const updatedOptions = [...currentOptions, AddOption];

      // Update the options array in Firestore
      await projectFirestore
        .collection("products")
        .doc(productId)
        .update({ options: updatedOptions });

      // Reset the AddOption state and close the input field
      setAddOption("");
      setIsAddOption(false);
    } catch (error) {
      console.error("Error adding new option:", error);
      // Handle the error as needed
    }
  };
  const handleCancelAddOption = () => {
    setIsAddOption(false);
  };
  const handleOptionChange = (index) => {
    setSelectedOption(!selectedOption);
    setIsOptionSelected(true);
    setSelectedOptionIndex(index);
  };
  // Fetch options array from the document state
  const options = document.options || [];
  // delete option
  const handleDeleteOption = async (index) => {
    try {
      // Get the current options array from the document
      const currentOptions = document.options || [];

      // Remove the selected option from the array
      const updatedOptions = currentOptions.filter((_, i) => i !== index);

      // Update the options array in Firestore
      await projectFirestore
        .collection("products")
        .doc(productId)
        .update({ options: updatedOptions });
    } catch (error) {
      console.error("Error deleting option:", error);
      // Handle the error as needed
    }
  };
  // END CODE FOR CATEGORY OPTIONS

  // RATING CODE START
  const handleRatingChange = (newValue) => {
    // Prevent setting the rating to null
    const newRating = newValue !== null ? newValue : rating;

    setRating(newRating);
    // Update the rating field in the Firebase document
    updateDocument(productId, { rating: newRating })
      .then(() => console.log("Rating updated successfully"))
      .catch((error) => console.error("Error updating rating:", error));
  };
  // END RATING CODE

  // START CODE FOR CHANGE PRODUCTS POPULARITY
  const handlePopularityToggleChange = (fieldName, currentStatus) => {
    const newStatus = !currentStatus; // Toggle the current boolean status
    // Update the status in Firestore
    updateDocument(productId, { [fieldName]: newStatus })
      .then(() => {
        switch (fieldName) {
          case "topSellingProducts":
            setCheckedTopSelling(newStatus);
            break;
          case "popularProducts":
            setCheckedPopular(newStatus);
            break;
          case "newArrivals":
            setCheckedNewArrivals(newStatus);
            break;
          case "isShippingAllow":
            setIsShippingAllow(newStatus);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        console.error("Error updating product status:", error);
      });
  };
  // END CODE FOR CHANGE PRODUCTS POPULARITY

  // Add these state variables at the top with other states

  // Add this function to handle form reset
  const resetCopyForm = () => {
    setSelectedRole("");
    setCopyProductForm({
      name: "",
      price: "",
      discount: "",
    });
  };

  // Add this function to handle form changes
  const handleCopyFormChange = (e) => {
    const { name, value } = e.target;
    setCopyProductForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle radio change
  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
    // When role is selected, pre-fill the form with current product details
    setCopyProductForm({
      name: document.name,
      price: document.price,
      discount: document.discount,
    });
  };

  // Handle copy product
  const handleCopyProduct = async () => {
    try {
      const newProductData = {
        ...document,
        id: null,
        name: copyProductForm.name,
        brand: document.brand || "", // Add brand
        model: document.model || "", // Add model
        sku: document.sku || "", // Add SKU
        hsn: document.hsn || "", // Add HSN
        price: copyProductForm.price,
        discount: copyProductForm.discount,
        buyerType: selectedRole,
        createdAt: new Date(),
        images: [
          "https://firebasestorage.googleapis.com/v0/b/smart-wash-80a57.appspot.com/o/master_data%2Fproduct_default_img%2Fimages.jfif?alt=media&token=14ec16c1-dab0-4bae-a086-63bf9ecbd967",
        ],
      };

      delete newProductData.id;

      // Add the new product to Firestore
      const newProductRef = await projectFirestore
        .collection("products")
        .add(newProductData);

      setIsCopyModalOpen(false);
      resetCopyForm();

      setSnackbarMessage("Product copied successfully");
      setSnackbarOpen(true);

      // Navigate to new product
      navigate(`/product-details-two/${newProductRef.id}`);
    } catch (error) {
      console.error("Error copying product:", error);
      setSnackbarMessage("Error copying product");
      setSnackbarOpen(true);
    }
  };

  const suggestedProductClicked = (suggestedPId) => {
    navigate(`/product-details-two/${suggestedPId}`);
  };

  // START CHANGE QR CODE IMAGE
  const handleAddPhotoClick = () => {
    setIsQrPopupOpen(true);
  };
  // Handle file selection
  const handleQrImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
      setImageFile(e.target.files[0]); // Store the file
    }
  };

  const handleConfirmUploadQr = async () => {
    if (!imageFile) return;
    setIsUploading(true); // Start uploading
    setUploadError(null);

    const storageRef = projectStorage.ref();
    const fileRef = storageRef.child(`QRCode/${imageFile.name}`);

    try {
      // Upload image to Firebase Storage
      await fileRef.put(imageFile);
      const downloadURL = await fileRef.getDownloadURL();

      // Update Firestore document with the image URL
      await updateQrCodeDocument("paymentDetails", {
        QRCodeImgUrl: downloadURL,
      });

      setIsQrPopupOpen(false);
    } catch (error) {
      setUploadError("Failed to upload image. Please try again.");
    } finally {
      setIsUploading(false); // Stop uploading
      setSelectedImage(null); // Reset image preview
    }
  };

  const handleCloseQrPopup = () => {
    setIsQrPopupOpen(false);
  };
  // END CHANGE QR CODE IMAGE

  // CHANGE UPI ID START
  const handleEditUpiId = () => {
    setIsEditingUpiId(!isEditingUpiId);
  };

  // Handler to save the updated UPI ID
  const handleSaveUpiId = async () => {
    const editedUpiId = upiId;
    try {
      // Update the UPI ID in Firestore or wherever it needs to be saved
      await updateQrCodeDocument("paymentDetails", { upiId: editedUpiId });
      setIsEditingUpiId(false); // Exit edit mode after saving
      setSnackbarMessage("UPI ID updated successfully");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating UPI ID:", error);
      setSnackbarMessage("Error updating UPI ID");
      setSnackbarOpen(true);
    }
  };
  // CHANGE UPI ID END

  const handleCopyProductId = () => {
    if (document?.productId) {
      navigator.clipboard.writeText(document.productId);
      setSnackbarMessage("Id Copied!");
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      <div className="services-details-parent-div">
        <Popup
          showPopupFlag={isDeletePopupOpen}
          setShowPopupFlag={setIsDeletePopupOpen}
          msg="Are you sure you want to delete this service?"
          setPopupReturn={(confirmed) => {
            if (confirmed) {
              handleConfirmDeleteProduct();
            }
          }}
        />

        {/* // Update color modal to include URL field */}

        <Modal
          open={isColorModalOpen}
          onClose={handleCloseColorModal}
          aria-labelledby="color-modal-title"
        >
          <Box sx={modalStyle}>
            <h2 id="color-modal-title">Add New Color</h2>
            <SketchPicker
              color={selectedInputColor}
              onChangeComplete={handleColorChange}
            />
            <TextField
              variant="outlined"
              type="text"
              label="Color Name"
              value={colorName}
              onChange={(e) => setColorName(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              variant="outlined"
              type="text"
              label="Color URL (Optional)"
              value={colorUrl}
              onChange={(e) => setColorUrl(e.target.value)}
              fullWidth
              margin="normal"
              placeholder="https://example.com or /product/123"
            />
            <div className="modal-actions">
              <Button variant="outlined" onClick={handleCloseColorModal}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveColor}
                disabled={!colorName}
              >
                Save
              </Button>
            </div>
          </Box>
        </Modal>
        {/* // Size modal component */}

        <Modal
          open={isSizeModalOpen}
          onClose={handleCloseSizeModal}
          aria-labelledby="size-modal-title"
        >
          <Box sx={modalStyle}>
            <h2 id="size-modal-title">Add New Size</h2>
            <TextField
              variant="outlined"
              type="text"
              label="Size Name"
              value={size}
              onChange={(e) => setSize(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              variant="outlined"
              type="text"
              label="Size URL (Optional)"
              value={sizeUrl}
              onChange={(e) => setSizeUrl(e.target.value)}
              fullWidth
              margin="normal"
              placeholder="https://example.com or /product/123"
            />
            <div className="modal-actions">
              <Button variant="outlined" onClick={handleCloseSizeModal}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveSize}
                disabled={!size}
              >
                Save
              </Button>
            </div>
          </Box>
        </Modal>
        {/* MODEL FOR ADD NEW VARIENTS */}
        <Modal
          open={isVariantModalOpen}
          onClose={handleVariantModalClose}
          aria-labelledby="variant-modal-title"
          aria-describedby="variant-modal-description"
        >
          <Box sx={modalStyle}>
            <h2 id="variant-modal-title">Add New Variant</h2>
            <TextField
              variant="outlined"
              type="text"
              label="Variant Name"
              name="variantName"
              value={variantInfo.variantName}
              onChange={handleVariantChange}
              fullWidth
              margin="normal"
            />
            <TextField
              variant="outlined"
              type="number"
              label="Variant Price"
              name="variantPrice"
              value={variantInfo.variantPrice}
              onChange={handleVariantChange}
              fullWidth
              margin="normal"
            />
            <TextField
              variant="outlined"
              type="text"
              label="Variant URL"
              name="variantUrl"
              value={variantInfo.variantUrl}
              onChange={handleVariantChange}
              fullWidth
              margin="normal"
            />
            <div className="modal-actions">
              <Button variant="outlined" onClick={handleVariantModalClose}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSaveVariant}>
                Save
              </Button>
            </div>
          </Box>
        </Modal>

        {/* MODEL FOR CHANGE PRODUCT CATEGORY AND SUB CAT */}
        <Modal
          open={isCategoryModalOpen}
          onClose={handleCategoryModalClose}
          aria-labelledby="variant-modal-title"
          aria-describedby="variant-modal-description"
        >
          <Box sx={modalStyle}>
            <h4 id="variant-modal-title">Change Product Category</h4>
            <hr />
            {/* Category Selection */}
            <Autocomplete
              multiple
              options={
                allcategories &&
                allcategories.filter((cat) => cat.status === "active")
              }
              getOptionLabel={(option) => option.category || ""}
              value={
                allcategories &&
                allcategories.filter(
                  (cat) =>
                    Array.isArray(
                      productCategory && productCategory.category
                    ) &&
                    productCategory &&
                    productCategory.category.includes(cat.category)
                )
              }
              onChange={handleCatInputChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Categories"
                  variant="outlined"
                />
              )}
              style={{ marginBottom: "10px" }}
            />

            {/* Subcategory Selection */}
            <Autocomplete
              multiple
              options={
                allcategories &&
                allcategories
                  .filter(
                    (cat) =>
                      Array.isArray(
                        productCategory && productCategory.category
                      ) &&
                      productCategory &&
                      productCategory.category.includes(cat.category)
                  )
                  .flatMap((cat) => cat.subCategories || [])
                  .filter((sub) => sub.status === "active")
              }
              getOptionLabel={(option) => option.subCategoryName || ""}
              value={
                allcategories &&
                allcategories
                  .flatMap((cat) => cat.subCategories || [])
                  .filter(
                    (sub) =>
                      Array.isArray(
                        productCategory && productCategory.subCategory
                      ) &&
                      productCategory &&
                      productCategory.subCategory.includes(sub.subCategoryName)
                  )
              }
              onChange={handleSubCategoryChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Subcategories"
                  variant="outlined"
                />
              )}
            />

            {/* Modal Actions */}
            <div className="modal-actions">
              <Button variant="outlined" onClick={handleCategoryModalClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => handleSaveClick("category")}
              >
                Confirm
              </Button>
            </div>
          </Box>
        </Modal>

        {/* START CHANGE QR CODE IMAGE */}
        {isQrPopupOpen && (
          <div className="pg_contact_us_popup-overlay">
            <div className="pg_contact_us_popup-content">
              <button
                className="pg_contact_us_close-btn"
                onClick={handleCloseQrPopup}
              >
                <span class="material-symbols-outlined">close</span>
              </button>
              <div className="pg_contact_us_selected-image-wrapper">
                <div
                  className={`pg_contact_us_selected-image-preview ${
                    isQrUploading ? "dull-background" : ""
                  }`}
                >
                  <img
                    src={
                      selectedImage || (qrCodeData && qrCodeData.QRCodeImgUrl)
                    }
                    alt="Selected"
                  />

                  {isQrUploading && (
                    <div className="pg_contact_us_uploading-gif-container">
                      <img
                        src="/assets/img/cloud-upload.gif"
                        alt="Uploading"
                        className="contact-section-uploading-gif"
                      />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleQrImageChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                {!isUploading && (
                  <button
                    className="btn_border"
                    onClick={() => fileInputRef.current.click()}
                  >
                    Replace Image
                  </button>
                )}

                <button
                  className="btn_fill"
                  onClick={handleConfirmUploadQr}
                  disabled={isUploading}
                >
                  {isUploading ? "Uploading..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        )}
        {/* END CHANGE QR CODE IMAGE */}

        <div className="prducts-details-top-suggestion-parent">
          <OwlCarousel
            loop
            dots={false}
            nav={false}
            autoplay={false}
            autoplayTimeout={8000}
            smartSpeed={4000}
            responsive={{
              0: { items: 1 },
              768: { items: 2 },
              1024: { items: 2 },
            }}
          >
            {allproducts &&
              allproducts
                .filter(
                  (document) =>
                    document.topSellingProducts === true &&
                    document.status === "active"
                )
                .map((product, index) => {
                  // Get first image
                  const firstImage =
                    Array.isArray(product.images) && product.images.length > 0
                      ? product.images[0]
                      : null;
                  const imageUrl = firstImage
                    ? typeof firstImage === "string"
                      ? firstImage
                      : firstImage.url
                    : null;
                  const imageDate =
                    typeof firstImage === "object" ? firstImage.date : null;
                  const imageDesc =
                    typeof firstImage === "object" ? firstImage.desc : null;

                  return (
                    <div
                      key={index}
                      className={`container ${
                        index % 2 === 0 ? "suggested-product-border-right" : ""
                      }`}
                      onClick={() => suggestedProductClicked(product.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="row">
                        <div className="product-details-top-suggestion-item">
                          <div className="d-flex">
                            {user && user.role === "admin" && (
                              <div
                                className="d-flex justify-content-end"
                                style={{ marginRight: "10px" }}
                                title="Top selling products are being shown here."
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    fontSize: "15px",
                                    color: "var(--black-color)",
                                  }}
                                >
                                  info
                                </span>
                              </div>
                            )}

                            {/* 👉 Render only first image */}
                            {imageUrl && (
                              <div className="products-details-top-suggestion-img-wrapper">
                                <img
                                  className="products-details-top-suggestion-img"
                                  src={imageUrl}
                                  alt="suggested product img"
                                />
                                {imageDate && (
                                  <small className="image-date">
                                    Date: {imageDate}
                                  </small>
                                )}
                                {imageDesc && (
                                  <small className="image-desc">
                                    Desc: {imageDesc}
                                  </small>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="products-details-top-suggestion-product-info">
                            <p className="products-details-top-suggestion-product-name">
                              <b>{product.name}</b>
                            </p>
                            <div className="products-details-top-suggestion-product-meta">
                              {product.rating && (
                                <div className="products-details-top-suggestion-product-rating">
                                  <Rating
                                    value={parseFloat(product.rating)}
                                    precision={0.5}
                                    readOnly
                                    getLabelText={getLabelText}
                                    emptyIcon={
                                      <StarIcon
                                        style={{ opacity: 0.45 }}
                                        fontSize="inherit"
                                      />
                                    }
                                  />
                                </div>
                              )}
                              {product.discount && (
                                <div className="products-details-top-suggestion-discount">
                                  {product.discount} off
                                </div>
                              )}
                              <div
                                className="products-details-top-suggestion-product-price"
                                style={{ color: "var(--text-grey)" }}
                              >
                                {currencyDocument.symbol}
                                {product.price}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </OwlCarousel>
        </div>

        <div className="container">
          <div className="d-flex justify-content-center product-details-pg-srvc-heading">
            <h5>{document && document.name}</h5>
          </div>

          <div className="services-images-slider-div-child">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6">
                <div className="pcs_image_area">
                  <div className="bigimage_container relative">
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "600px",
                      }}
                    >
                      {/* Delete Confirmation Popup */}
                      <Modal
                        open={deleteConfirmation.isOpen}
                        onClose={() =>
                          setDeleteConfirmation({
                            isOpen: false,
                            imageToDelete: null,
                            imageIndex: null,
                          })
                        }
                        aria-labelledby="delete-confirmation-modal"
                        aria-describedby="delete-confirmation-description"
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: "65%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 5,
                            borderRadius: "8px",
                          }}
                        >
                          <p
                            id="delete-confirmation-description"
                            style={{ marginBottom: "20px" }}
                          >
                            Are you sure you want to delete this image?
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "15px",
                            }}
                          >
                            <Button
                              variant="outlined"
                              onClick={() =>
                                setDeleteConfirmation({
                                  isOpen: false,
                                  imageToDelete: null,
                                  imageIndex: null,
                                })
                              }
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={handleDeleteImage}
                            >
                              Delete
                            </Button>
                          </div>
                        </Box>
                      </Modal>

                      <Gallery
                        items={(document?.images || [])
                          .map((img, index) => {
                            const url =
                              typeof img === "string" ? img : img?.url;
                            const description =
                              typeof img === "string"
                                ? `Image ${index + 1}`
                                : img?.description || `Image ${index + 1}`;

                            if (!url) return null;

                            return {
                              original: url,
                              thumbnail: url,
                              originalAlt: description,
                              thumbnailAlt: description,
                              loading: "lazy",
                              renderItem: (item) => (
                                <div className="image-gallery-image-container">
                                  <ReactImageMagnify
                                    className="image-gallery-image"
                                    {...{
                                      smallImage: {
                                        alt: item.originalAlt,
                                        isFluidWidth: true,
                                        src: item.original,
                                      },
                                      largeImage: {
                                        src: item.original,
                                        width: 2000, // Large image size should be 2-3x bigger than small image
                                        height: 2000,
                                      },
                                      enlargedImageContainerDimensions: {
                                        width: "100%",
                                        height: "100%",
                                      },
                                      enlargedImagePosition: "over",
                                      isHintEnabled: true,
                                      enlargedImageContainerStyle: {
                                        background: "white",
                                        zIndex: 999,
                                      },
                                    }}
                                  />
                                  {user && user.role === "admin" && (
                                    <button
                                      className="gallery-delete-button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openDeleteConfirmation(url, index);
                                      }}
                                    >
                                      <span className="material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  )}

                                  {document && document.productId && (
                                    <p
                                      className="product-id-n-gallery-img"
                                      onClick={handleCopyProductId}
                                      style={{ cursor: "pointer" }}
                                      title="Click to copy ID"
                                    >
                                      {document && document.productId}
                                    </p>
                                  )}
                                </div>
                              ),
                            };
                          })
                          .filter(Boolean)}
                        slideDuration={1000}
                      />
                    </div>
                    <Link
                      className="property_image"
                      to={`/product-images/${productId}`}
                    >
                      <div className="property_image_inner">
                        <span className="number">
                          {images.filter((url) => url).length}
                          <h6>Photos</h6>
                          <div className="arrow-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="20px"
                              viewBox="0 -960 960 960"
                              width="20px"
                              fill="#FFFFFF"
                            >
                              <path d="M630-444H192v-72h438L429-717l51-51 288 288-288 288-51-51 201-201Z" />
                            </svg>
                          </div>
                        </span>
                      </div>
                    </Link>

                    {user && user.role === "admin" && (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ margin: "15px 0px" }}
                      >
                        <input
                          type="file"
                          accept="image/*"
                          id="imageInput"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                          ref={fileInputRef}
                        />

                        <button
                          className="btn_fill me-2"
                          onClick={() => setShowImageUploadModal(true)}
                        >
                          Add More Images
                        </button>

                        {/* Image Upload Modal */}
                        {showImageUploadModal && (
                          <div className="image-upload-modal-overlay">
                            <div className="image-upload-modal">
                              <div className="modal-header">
                                <h5>Upload New Image</h5>
                                <button
                                  className="close-btn"
                                  onClick={() => {
                                    setShowImageUploadModal(false);
                                    handleCancelUpload();
                                  }}
                                >
                                  ×
                                </button>
                              </div>

                              <div className="modal-body">
                                <div className="form-group">
                                  <label>Image Description (Optional)</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={imageDescription}
                                    onChange={(e) =>
                                      setImageDescription(e.target.value)
                                    }
                                    placeholder="Enter image description"
                                  />
                                </div>

                                <div
                                  className="image-upload-area"
                                  onClick={() => fileInputRef.current.click()}
                                >
                                  {selectedImage ? (
                                    <img
                                      src={selectedImage}
                                      alt="Preview"
                                      className="image-preview"
                                    />
                                  ) : (
                                    <div className="upload-placeholder">
                                      <span className="material-symbols-outlined">
                                        image
                                      </span>
                                      <p>Click to select an image</p>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="modal-footer">
                                <button
                                  className="btn_border"
                                  onClick={() => {
                                    setShowImageUploadModal(false);
                                    handleCancelUpload();
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn_fill"
                                  onClick={() => {
                                    handleConfirmUpload();
                                    setShowImageUploadModal(false);
                                  }}
                                  disabled={!selectedImage || isUploading}
                                >
                                  {isUploading ? "Uploading..." : "Save Image"}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {selectedImage && (
                      <div style={{ textAlign: "center", marginTop: "15px" }}>
                        <img
                          src={selectedImage}
                          alt="Selected img"
                          style={{ maxWidth: "100px" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-6 services_details_right_dv">
                <MDBCard className="mb-4">
                  <MDBCardBody>
                    {productDetailsVisibility &&
                      productDetailsVisibility.productName && (
                        <MDBRow>
                          <MDBCol sm="3">
                            <MDBCardText>Name:</MDBCardText>
                          </MDBCol>
                          <MDBCol sm="9">
                            <MDBCardText className="text-muted">
                              {isEditingName ? (
                                <div>
                                  <Box
                                    sx={{
                                      "& .MuiTextField-root": { width: "100%" },
                                    }}
                                    noValidate
                                    autoComplete="on"
                                  >
                                    <TextField
                                      id="outlined-multiline-flexible"
                                      label="Name"
                                      multiline
                                      maxRows={4}
                                      value={editedName}
                                      onChange={(e) =>
                                        setEditedName(e.target.value)
                                      }
                                    />
                                  </Box>
                                  <div className="d-flex justify-content-end mt-2 gap-2">
                                    <button
                                      className="btn_border"
                                      onClick={() => handleCancelClick("name")}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      className="btn_fill"
                                      onClick={() => handleSaveClick("name")}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className="d-flex align-items-center">
                                  <p>{document && document.name}</p>
                                  {!isEditingName &&
                                    user &&
                                    user.role === "admin" && (
                                      <FaEdit
                                        style={{
                                          fontSize: 20,
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          color: "var(--click-color)",
                                        }}
                                        onClick={() => handleEditClick("name")}
                                      />
                                    )}
                                </div>
                              )}
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                      )}
                    {/* Add this after the Name field */}

                    {(user?.role === "admin" || document?.brand) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productBrand && (
                        <>
                          <hr />

                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Brand:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingBrand ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-brand"
                                        label="Brand"
                                        value={editedBrand}
                                        onChange={(e) =>
                                          setEditedBrand(e.target.value)
                                        }
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <button
                                        className="btn_border"
                                        onClick={() => {
                                          setEditedBrand(document.brand || "");
                                          setIsEditingBrand(false);
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={async () => {
                                          try {
                                            await updateDocument(productId, {
                                              brand: editedBrand,
                                            });
                                            setIsEditingBrand(false);
                                          } catch (error) {
                                            console.error(
                                              "Error updating brand:",
                                              error
                                            );
                                          }
                                        }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <p>
                                      {(document && document.brand) ||
                                        "Not specified"}
                                    </p>
                                    {user && user.role === "admin" && (
                                      <FaEdit
                                        style={{
                                          fontSize: 20,
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          color: "var(--click-color)",
                                        }}
                                        onClick={() => setIsEditingBrand(true)}
                                      />
                                    )}
                                  </div>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {(user?.role === "admin" || document?.model) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productModel && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Model:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingModel ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-model"
                                        label="Model"
                                        value={editedModel}
                                        onChange={(e) =>
                                          setEditedModel(e.target.value)
                                        }
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <button
                                        className="btn_border"
                                        onClick={() => {
                                          setEditedModel(document.model || "");
                                          setIsEditingModel(false);
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={async () => {
                                          try {
                                            await updateDocument(productId, {
                                              model: editedModel,
                                            });
                                            setIsEditingModel(false);
                                          } catch (error) {
                                            console.error(
                                              "Error updating model:",
                                              error
                                            );
                                          }
                                        }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <p>
                                      {(document && document.model) ||
                                        "Not specified"}
                                    </p>
                                    {user && user.role === "admin" && (
                                      <FaEdit
                                        style={{
                                          fontSize: 20,
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          color: "var(--click-color)",
                                        }}
                                        onClick={() => setIsEditingModel(true)}
                                      />
                                    )}
                                  </div>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}
                    {/* SKU Field */}
                    {(user?.role === "admin" || document?.sku) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productSKU && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>SKU:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingSku ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-sku"
                                        label="SKU Code"
                                        value={editedSku}
                                        onChange={(e) =>
                                          setEditedSku(e.target.value)
                                        }
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <button
                                        className="btn_border"
                                        onClick={() => {
                                          setEditedSku(document.sku || "");
                                          setIsEditingSku(false);
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={async () => {
                                          try {
                                            await updateDocument(productId, {
                                              sku: editedSku,
                                            });
                                            setIsEditingSku(false);
                                          } catch (error) {
                                            console.error(
                                              "Error updating SKU:",
                                              error
                                            );
                                          }
                                        }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <p>
                                      {(document && document.sku) ||
                                        "Not specified"}
                                    </p>
                                    {user && user.role === "admin" && (
                                      <FaEdit
                                        style={{
                                          fontSize: 20,
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          color: "var(--click-color)",
                                        }}
                                        onClick={() => setIsEditingSku(true)}
                                      />
                                    )}
                                  </div>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}
                    {/* HSN Field */}
                    {(user?.role === "admin" || document?.hsn) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productHSN && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>HSN:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingHsn ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-hsn"
                                        label="HSN Code"
                                        value={editedHsn}
                                        onChange={(e) =>
                                          setEditedHsn(e.target.value)
                                        }
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <button
                                        className="btn_border"
                                        onClick={() => {
                                          setEditedHsn(document.hsn || "");
                                          setIsEditingHsn(false);
                                        }}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={async () => {
                                          try {
                                            await updateDocument(productId, {
                                              hsn: editedHsn,
                                            });
                                            setIsEditingHsn(false);
                                          } catch (error) {
                                            console.error(
                                              "Error updating HSN:",
                                              error
                                            );
                                          }
                                        }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <p>
                                      {(document && document.hsn) ||
                                        "Not specified"}
                                    </p>
                                    {user && user.role === "admin" && (
                                      <FaEdit
                                        style={{
                                          fontSize: 20,
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                          color: "var(--click-color)",
                                        }}
                                        onClick={() => setIsEditingHsn(true)}
                                      />
                                    )}
                                  </div>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {productDetailsVisibility &&
                      productDetailsVisibility.productCategory && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Category:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                <div className="d-flex align-items-center">
                                  <p>
                                    {Array.isArray(document.category)
                                      ? document.category.join(", ")
                                      : typeof document.category === "string"
                                      ? document.category
                                      : ""}
                                  </p>
                                  {user && user.role === "admin" && (
                                    <FaEdit
                                      style={{
                                        fontSize: 20,
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        color: "var(--click-color)",
                                      }}
                                      onClick={handleCategoryModalOpen}
                                    />
                                  )}
                                </div>
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {productDetailsVisibility &&
                      productDetailsVisibility.productRating && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Rating:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                <MDBRow>
                                  <div className="d-flex align-items-center">
                                    <Box
                                      sx={{
                                        width: 200,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Rating
                                        value={parseFloat(document.rating)}
                                        precision={0.5}
                                        readOnly={
                                          (user && user.role !== "admin") ||
                                          "superAdmin"
                                        }
                                        getLabelText={getLabelText}
                                        onChange={(event, newValue) =>
                                          handleRatingChange(newValue)
                                        }
                                        // onChangeActive={(event, newHover) => {
                                        //   setHover(newHover);
                                        // }}
                                        emptyIcon={
                                          <StarIcon
                                            style={{ opacity: 0.45 }}
                                            fontSize="inherit"
                                          />
                                        }
                                      />
                                    </Box>
                                  </div>
                                </MDBRow>
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {/* START PRICE */}

                    {((user && user.role === "admin") ||
                      (document.price &&
                        document.price !== "" &&
                        document.price != 0)) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productPrice && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Price:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingPrice ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-multiline-flexible"
                                        label="Price"
                                        type="number"
                                        inputProps={{
                                          min: "0",
                                          step: "0.01", // Allows decimal values
                                        }}
                                        value={editedPrice}
                                        onChange={(e) => {
                                          // Only allow numbers and decimal points
                                          const value = e.target.value;
                                          if (
                                            value === "" ||
                                            /^[0-9]*\.?[0-9]*$/.test(value)
                                          ) {
                                            setEditedPrice(value);
                                          }
                                        }}
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <select
                                        value={priceType}
                                        onChange={(e) =>
                                          setPriceType(e.target.value)
                                        }
                                      >
                                        <option value="Fixed">Fixed</option>
                                        <option value="Onward">Onward</option>
                                      </select>

                                      <button
                                        className="btn_border"
                                        onClick={() =>
                                          handleCancelClick("price")
                                        }
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={() => handleSaveClick("price")}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <p>
                                      {currencyDocument &&
                                        currencyDocument.symbol}
                                      {selectedVariant
                                        ? selectedVariantPrice
                                        : document && document.price}
                                    </p>
                                    {document &&
                                      document.priceType === "Onward" && (
                                        <p>
                                          &nbsp;
                                          {document && document.priceType}
                                        </p>
                                      )}
                                    &nbsp;&nbsp;
                                    <del style={{ color: "red" }}>
                                      <p>{document && document.discount}</p>
                                    </del>
                                    {!isEditingPrice &&
                                      user &&
                                      user.role === "admin" && (
                                        <FaEdit
                                          style={{
                                            fontSize: 20,
                                            cursor: "pointer",
                                            marginLeft: "10px",
                                            color: "var(--click-color)",
                                          }}
                                          onClick={() =>
                                            handleEditClick("price")
                                          }
                                        />
                                      )}
                                  </div>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {((user && user.role === "admin") ||
                      (document.discount && document.discount !== "")) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productDiscount && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Discount:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingDiscount ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-multiline-flexible"
                                        label="Discount"
                                        maxRows={4}
                                        value={editedDiscount}
                                        onChange={(e) =>
                                          setEditedDiscount(e.target.value)
                                        }
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <button
                                        className="btn_border"
                                        onClick={() =>
                                          handleCancelClick("discount")
                                        }
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={() =>
                                          handleSaveClick("discount")
                                        }
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <p>{document && document.discount}</p>
                                    {!isEditingName &&
                                      user &&
                                      user.role == "admin" && (
                                        <FaEdit
                                          style={{
                                            fontSize: 20,
                                            cursor: "pointer",
                                            marginLeft: "10px",
                                            color: "var(--click-color)",
                                          }}
                                          onClick={() =>
                                            handleEditClick("discount")
                                          }
                                        />
                                      )}
                                  </div>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {productDetailsVisibility &&
                      productDetailsVisibility.GST &&
                      document.gst &&
                      document.gst !== "" &&
                      document.gst != 0 && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>GST:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                <div className="d-flex align-items-center">
                                  <p>
                                    {document && document.gst
                                      ? document.gst
                                      : TAXDocument && TAXDocument.gst}
                                  </p>
                                </div>
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {((user && user.role === "admin") ||
                      (document.discount && document.discount !== "")) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productDiscount && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Final Price:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {
                                  <div className="d-flex align-items-center">
                                    <p>
                                      {currencyDocument.symbol}
                                      {(() => {
                                        const discountValue =
                                          typeof document.discount === "number"
                                            ? document.discount
                                            : 0;

                                        const price = selectedVariant
                                          ? discountedPrice
                                          : document.price -
                                            Math.ceil(
                                              (document.price * discountValue) /
                                                100
                                            );

                                        // Use product GST if available, else fallback to default GST
                                        const gstPercentage = parseFloat(
                                          (document.gst && document.gst !== ""
                                            ? document.gst
                                            : TAXDocument?.gst) || 0
                                        );

                                        const gstAmount =
                                          (price * gstPercentage) / 100;
                                        const finalPriceWithGST = Math.round(
                                          price + gstAmount
                                        );

                                        return finalPriceWithGST;
                                      })()}
                                    </p>
                                  </div>
                                }
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {productDetailsVisibility &&
                      productDetailsVisibility.productShortDescription && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Short Description:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                {isEditingShortDescription ? (
                                  <div>
                                    <Box
                                      sx={{
                                        "& .MuiTextField-root": {
                                          width: "100%",
                                        },
                                      }}
                                      noValidate
                                      autoComplete="on"
                                    >
                                      <TextField
                                        id="outlined-multiline-flexible"
                                        label="Short Description"
                                        multiline
                                        maxRows={4}
                                        value={editedShortDescription}
                                        onChange={(e) =>
                                          setEditedShortDescription(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Box>
                                    <div className="d-flex justify-content-end mt-2 gap-2">
                                      <button
                                        className="btn_border"
                                        onClick={() =>
                                          handleCancelClick("shortdescription")
                                        }
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn_fill"
                                        onClick={() =>
                                          handleSaveClick("shortdescription")
                                        }
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div className="d-flex align-items-center">
                                      <p>
                                        {document && document.short_description}
                                      </p>
                                      {!isEditingShortDescription &&
                                        user &&
                                        user.role == "admin" && (
                                          <FaEdit
                                            style={{
                                              fontSize: 20,
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                              color: "var(--click-color)",
                                            }}
                                            onClick={() =>
                                              handleEditClick(
                                                "shortdescription"
                                              )
                                            }
                                          />
                                        )}
                                    </div>
                                  </>
                                )}
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {((user && user.role === "admin") ||
                      (document.external_url &&
                        document.external_url !== "")) &&
                      productDetailsVisibility &&
                      productDetailsVisibility.productPreview && (
                        <>
                          <hr />
                          <MDBRow>
                            <MDBCol sm="3">
                              <MDBCardText>Preview:</MDBCardText>
                            </MDBCol>
                            <MDBCol sm="9">
                              <MDBCardText className="text-muted">
                                <div>
                                  {isEditingProductUrl ? (
                                    <div>
                                      <TextEditor
                                        initialDescription={editedExternalUrl}
                                        docFieldName="external_url"
                                        documentId={productId}
                                        collectionName="products"
                                        onSave={() =>
                                          handleSaveClick("externalurl")
                                        }
                                        onCancel={() =>
                                          handleCancelClick("externalurl")
                                        }
                                      />
                                    </div>
                                  ) : (
                                    <div className="d-flex">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            document.external_url.toString(
                                              "html"
                                            ),
                                        }}
                                      ></p>
                                      {!isEditingProductUrl &&
                                        user &&
                                        user.role === "admin" && (
                                          <FaEdit
                                            style={{
                                              fontSize: 20,
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                              color: "var(--click-color)",
                                            }}
                                            onClick={() =>
                                              handleEditClick("producturl")
                                            }
                                          />
                                        )}
                                    </div>
                                  )}
                                </div>
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      )}

                    {appTypeDocument &&
                    appTypeDocument.apptype === "lite" ? null : (
                      <>
                        <hr />
                        <MDBRow>
                          <div className="radio-container">
                            {options.map((option, index) => (
                              <label
                                key={index}
                                className={`radio-container ${
                                  selectedOptionIndex === index
                                    ? "radio_btn_checked"
                                    : " service_details_radion_btn"
                                }`}
                              >
                                <div className="d-flex align-items-center">
                                  <input
                                    type="radio"
                                    name="option"
                                    value={option}
                                    onChange={() => handleOptionChange(index)}
                                    className="radio-button-with-radius"
                                  />
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "21px" }}
                                  >
                                    {selectedOptionIndex === index
                                      ? "done"
                                      : "add"}
                                  </span>
                                  {selctedOption && options}
                                  {user && user.role === "admin" ? (
                                    <span
                                      class="material-symbols-outlined"
                                      onClick={() => handleDeleteOption(index)}
                                    >
                                      close
                                    </span>
                                  ) : null}
                                </div>
                              </label>
                            ))}
                            {isAddOption ? (
                              <div>
                                <input
                                  type="text"
                                  value={AddOption}
                                  onChange={(e) => setAddOption(e.target.value)}
                                />
                                <div className="d-flex">
                                  <button
                                    className="product_edit_save_btn"
                                    onClick={handleSaveAddOption}
                                  >
                                    Save
                                  </button>
                                  <button
                                    className="product_edit_save_btn cancel-btn"
                                    onClick={handleCancelAddOption}
                                    style={{ marginLeft: "10px" }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <>
                                {user && user.role == "admin" && (
                                  <span
                                    class="material-symbols-outlined"
                                    onClick={handleAddOptionClick}
                                    style={{ fontSize: "24px" }}
                                  >
                                    add_box
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                        </MDBRow>
                      </>
                    )}

                    {isColorVisible && (
                      <>
                        <hr />
                        <MDBRow>
                          <MDBCol sm="3">Colors:</MDBCol>
                          <MDBCol sm="9">
                            <div className="colors-container">
                              {document &&
                                document.colors &&
                                document.colors.map((color, index) => (
                                  <div
                                    key={index}
                                    className={`color-capsule ${
                                      selectedColor?.colorName ===
                                      color.colorName
                                        ? "selected-color"
                                        : ""
                                    }`}
                                    onClick={() => handleSelectedColor(color)}
                                  >
                                    <div
                                      className="color-disc"
                                      style={{ backgroundColor: color.color }}
                                    ></div>
                                    <span className="color-name">
                                      {color.colorName}
                                    </span>
                                    {user && user.role === "admin" && (
                                      <button
                                        className="delete-color-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteColor(color);
                                        }}
                                      >
                                        <span className="material-symbols-outlined">
                                          close
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                ))}
                              {user && user.role === "admin" && (
                                <button
                                  className="add-color-btn"
                                  onClick={handleOpenColorModal}
                                >
                                  <span className="material-symbols-outlined">
                                    add
                                  </span>
                                </button>
                              )}
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </>
                    )}

                    {isSizeVisible && (
                      <>
                        <hr />
                        <MDBRow>
                          <MDBCol sm="3">Size:</MDBCol>
                          <MDBCol sm="9">
                            <div className="sizes-container">
                              {document &&
                                document.sizes &&
                                document.sizes.map((sizeObj, index) => (
                                  <div
                                    key={index}
                                    className={`size-capsule ${
                                      selectedSize?.size === sizeObj.size
                                        ? "selected-size"
                                        : ""
                                    }`}
                                    onClick={() => handleSelectedSize(sizeObj)}
                                  >
                                    <span className="size-name">
                                      {sizeObj.size}
                                    </span>
                                    {user && user.role === "admin" && (
                                      <span
                                        className="material-symbols-outlined"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteSize(sizeObj);
                                        }}
                                      >
                                        close
                                      </span>
                                    )}
                                  </div>
                                ))}
                              {user && user.role === "admin" && (
                                <button
                                  className="add-size-btn"
                                  onClick={handleOpenSizeModal}
                                >
                                  <span className="material-symbols-outlined">
                                    add
                                  </span>
                                </button>
                              )}
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </>
                    )}
                    {isVariantVisible && (
                      <>
                        <hr />
                        <MDBRow>
                          <MDBCol sm="3">Variants:</MDBCol>
                          <MDBCol sm="9">
                            <div className="variants-container">
                              {document &&
                                document.variants &&
                                document.variants.map((variant, index) => (
                                  <div
                                    key={index}
                                    className={`variant-capsule ${
                                      selectedVariant?.variantName ===
                                      variant.variantName
                                        ? "variant_btn_checked"
                                        : ""
                                    }`}
                                    onClick={() => handleVariantClick(variant)}
                                  >
                                    <span className="variant-name">
                                      {variant.variantName}
                                    </span>
                                    <span className="variant-price">
                                      {currencyDocument.symbol}{" "}
                                      {variant.variantPrice}
                                    </span>
                                    {user && user.role === "admin" && (
                                      <span
                                        className="material-symbols-outlined"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteVariant(variant);
                                        }}
                                      >
                                        close
                                      </span>
                                    )}
                                  </div>
                                ))}
                              {user && user.role === "admin" && (
                                <button
                                  className="add-color-btn"
                                  onClick={handleVariantModalOpen}
                                >
                                  <span className="material-symbols-outlined">
                                    add
                                  </span>
                                </button>
                              )}
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </>
                    )}
                  </MDBCardBody>
                </MDBCard>
                <div className="d-flex align-items-center namesd">
                  <MDBCol className="d-flex align-items-center">
                    <MDBCardText style={{ cursor: "pointer" }}>
                      <span
                        className="material-symbols-outlined"
                        onClick={shareURL}
                        style={{ margin: "6px 0px 0px 5px", fontSize: "28px" }}
                      >
                        share
                      </span>
                    </MDBCardText>

                    {isProductInWishlist(document.id) ? (
                      <button
                        onClick={() =>
                          handleWishlistRemove(findWishlistItem(document.id))
                        }
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        title="Remove from Wishlist"
                      >
                        {/* Filled red heart SVG */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="30px"
                          viewBox="0 0 24 24"
                          width="30px"
                          fill="red"
                          style={{ marginLeft: "5px" }}
                        >
                          <path
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
        2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 
        4.5 2.09C13.09 3.81 14.76 3 16.5 3 
        19.58 3 22 5.42 22 8.5c0 3.78-3.4 
        6.86-8.55 11.54L12 21.35z"
                          />
                        </svg>
                      </button>
                    ) : (
                      <button
                        onClick={() => handleAddToWishlist(document.id)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        title="Add to Wishlist"
                      >
                        {/* Outline black heart SVG */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="30px"
                          viewBox="0 0 24 24"
                          width="30px"
                          fill="none"
                          stroke="black"
                          strokeWidth="2"
                          style={{ marginLeft: "5px" }}
                        >
                          <path
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
        2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 
        4.5 2.09C13.09 3.81 14.76 3 16.5 3 
        19.58 3 22 5.42 22 8.5c0 3.78-3.4 
        6.86-8.55 11.54L12 21.35z"
                          />
                        </svg>
                      </button>
                    )}

                    {(bookingCount && parseInt(bookingCount) > 0) ||
                    user?.role === "admin" ? (
                      user?.role === "admin" ? (
                        isEditingBookingCount ? (
                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              value={editedBookingCount}
                              onChange={(e) =>
                                setEditedBookingCount(e.target.value)
                              }
                              style={{
                                width: "70px",
                                padding: "2px 5px",
                                marginLeft: "5px",
                              }}
                              placeholder="200+"
                            />
                            <button
                              className="btn_fill ms-2"
                              onClick={handleSaveBookingCount}
                              style={{ padding: "2px 8px" }}
                            >
                              Save
                            </button>
                            <button
                              className="btn_border ms-2"
                              onClick={() => setIsEditingBookingCount(false)}
                              style={{ padding: "2px 8px" }}
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <div
                            className="d-flex align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsEditingBookingCount(true)}
                          >
                            <MDBCardText
                              style={{ display: "flex", paddingLeft: "7px" }}
                            >
                              <h4 style={{ fontSize: "20px" }}>
                                | &nbsp; {bookingCount}
                              </h4>
                            </MDBCardText>
                            <FaEdit
                              style={{
                                fontSize: 20,
                                marginLeft: "5px",
                                color: "var(--click-color)",
                              }}
                            />
                          </div>
                        )
                      ) : (
                        parseInt(bookingCount) > 0 && (
                          <MDBCardText
                            style={{ display: "flex", paddingLeft: "7px" }}
                          >
                            <h4 style={{ fontSize: "22px" }}>
                              | {bookingCount}
                            </h4>
                          </MDBCardText>
                        )
                      )
                    ) : null}
                  </MDBCol>

                  {/* {appTypeDocument && appTypeDocument.apptype === "lite" ? (
                    <>
                      {user ? (
                        functionTypeDocument &&
                        functionTypeDocument.function === "ecommerce" ? (
                          <div className="more-div-big-icon-div-inner pointer">
                            <Link to="/contact">
                              <button
                                type="submit"
                                className="booking_services_book_now_btn"
                              >
                                Check Out
                              </button>
                            </Link>
                          </div>
                        ) : (
                          <div className="more-div-big-icon-div-inner pointer">
                            <Link
                              to={`/basicaddbooking/${document && document.id}`}
                            >
                              <button
                                type="submit"
                                className="booking_services_book_now_btn"
                                disabled={!isOptionSelected}
                              >
                                Book Now
                              </button>
                            </Link>
                          </div>
                        )
                      ) : (
                        <div className="more-div-big-icon-div-inner pointer">
                          <Link to="/contact">
                            <button
                              type="submit"
                              className="booking_services_book_now_btn"
                            >
                              Contact
                            </button>
                          </Link>
                        </div>
                      )}
                    </>
                  ) : ( */}
                  <>
                    {pageControlDoc && pageControlDoc.login === true && (
                      <div className="more-div-big-icon-div-inner pointer">
                        {pageControlDoc && pageControlDoc.checkOut === true && (
                          <Link to={`/checkout/${document && document.id}`}>
                            <button
                              // onClick={() => handleAddToCart(document.id)}
                              className="product-details-add-to-cart-btn"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 -960 960 960"
                                width="24px"
                                fill="currentColor"
                              >
                                <path d="m480-560-56-56 63-64H320v-80h167l-64-64 57-56 160 160-160 160ZM280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM40-800v-80h131l170 360h280l156-280h91L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68.5-39t-1.5-79l54-98-144-304H40Z" />
                              </svg>
                              Checkout
                            </button>
                          </Link>
                        )}
                        {pageControlDoc && pageControlDoc.cart === true && (
                          <>
                            &nbsp;
                            <button
                              onClick={() => handleAddToCart(document.id)}
                              className="product-details-add-to-cart-btn"
                            >
                              Add to cart
                            </button>
                          </>
                        )}
                      </div>
                    )}
                    {/* )
                       : (
                        <div className="more-div-big-icon-div-inner pointer">
                          <Link to="/login">
                            <button
                              type="submit"
                              className="booking_services_book_now_btn"
                              style={{
                                padding: "10px 50px ",
                                borderRadius: "5px",
                                border: "none",
                                outline: "none",
                                color: "white",
                                fontWeight: "500",
                                fontSize: "20px",
                                backgroundColor: "var(--click-color)",
                              }}
                            >
                              Checkout
                            </button>
                          </Link>
                        </div>
                      )} */}
                  </>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>

          {user && user.role === "admin" && (
            <div className="row mb-4">
              <div className="col-12">
                <MDBCard className="admin-controls-card">
                  <MDBCardBody>
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                      <h5>Product Settings</h5>
                      <button
                        className="copy-button"
                        onClick={() => {
                          setIsCopyModalOpen(true);
                          // Pre-fill form with current product details
                          setCopyProductForm({
                            name: document.name,
                            price: document.price,
                            discount: document.discount,
                            buyerType: document.buyerType,
                          });
                        }}
                        title="Create copy of product"
                      >
                        Duplicate Product
                      </button>
                    </div>

                    <div className="admin-controls-grid">
                      {/* Product Status Section */}
                      <div className="control-section">
                        <div className="control-section-part">
                          <div className="section-header">
                            <h6 className="section-title">Product Status</h6>
                          </div>
                          <div className="toggle-group">
                            <div className="toggle-item">
                              <span className="toggle-label">Status</span>
                              <div className="toggle-control">
                                <span
                                  className={`status-label ${
                                    document.status !== "active" ? "active" : ""
                                  }`}
                                >
                                  Inactive
                                </span>
                                <ReactSwitch
                                  checked={
                                    document && document.status === "active"
                                  }
                                  onChange={() =>
                                    handleStatusToggleChange(
                                      document.id,
                                      document.status
                                    )
                                  }
                                  onColor="#149AA2"
                                  offColor="#F05B83"
                                  className="products-status-switch"
                                  // className="products-status-switch"
                                />
                                <span
                                  className={`status-label ${
                                    document.status === "active" ? "active" : ""
                                  }`}
                                >
                                  Active
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="control-section-part">
                          <div className="section-header">
                            <h6 className="section-title">
                              Quantity Management
                            </h6>
                          </div>
                          <div
                            className="toggle-group"
                            onClick={() => setIsQuantityModalOpen(true)}
                          >
                            <div className="toggle-item">
                              <span className="toggle-label">
                                Manage Quantity Settings
                              </span>
                              <span className="material-symbols-outlined">
                                arrow_forward
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Product Type Section */}
                      <div className="control-section">
                        <h6 className="section-title">Show Product To</h6>
                        <div className="radio-group">
                          {["dealer", "retailer", "customer"].map((role) => (
                            <div key={role} className="radio-label-container">
                              <label className="radio-label">
                                <input
                                  type="radio"
                                  name="buyerType"
                                  value={role}
                                  checked={
                                    document && document.buyerType === role
                                  }
                                  onChange={async (e) => {
                                    try {
                                      await updateDocument(productId, {
                                        buyerType: e.target.value,
                                      });
                                    } catch (error) {
                                      console.error(
                                        "Error updating buyer type:",
                                        error
                                      );
                                    }
                                  }}
                                />
                                <span className="radio-text">
                                  {role.charAt(0).toUpperCase() + role.slice(1)}
                                </span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Product Features Section */}
                      <div className="control-section">
                        <h6 className="section-title">Product Features</h6>
                        <div className="toggle-group">
                          <div className="toggle-item">
                            <span className="toggle-label">Color Options</span>
                            <ReactSwitch
                              checked={isColorVisible}
                              onChange={handleColorVisibilityToggle}
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>

                          <div className="toggle-item">
                            <span className="toggle-label">Size Options</span>
                            <ReactSwitch
                              checked={isSizeVisible}
                              onChange={handleSizeVisibilityToggle}
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                          <div className="toggle-item">
                            <span className="toggle-label">Variants</span>
                            <ReactSwitch
                              checked={isVariantVisible}
                              onChange={handleVariantVisibilityToggle}
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                          <div className="toggle-item">
                            <span className="toggle-label">Allow Shipping</span>
                            <ReactSwitch
                              checked={
                                document && document.isShippingAllow === true
                              }
                              onChange={() =>
                                handlePopularityToggleChange(
                                  "isShippingAllow",
                                  isShippingAllow
                                )
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Product Categories Section */}
                      <div className="control-section">
                        <div className="section-header">
                          <h6 className="section-title">Product Categories</h6>
                        </div>
                        <div className="toggle-group">
                          <div className="toggle-item">
                            <span className="toggle-label">Top Selling</span>
                            <ReactSwitch
                              checked={
                                document && document.topSellingProducts === true
                              }
                              onChange={() =>
                                handlePopularityToggleChange(
                                  "topSellingProducts",
                                  checkedTopSelling
                                )
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                          <div className="toggle-item">
                            <span className="toggle-label">Popular Items</span>
                            <ReactSwitch
                              checked={
                                document && document.popularProducts === true
                              }
                              onChange={() =>
                                handlePopularityToggleChange(
                                  "popularProducts",
                                  checkedPopular
                                )
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                          <div className="toggle-item">
                            <span className="toggle-label">New Arrival</span>
                            <ReactSwitch
                              checked={
                                document && document.newArrivals === true
                              }
                              onChange={() =>
                                handlePopularityToggleChange(
                                  "newArrivals",
                                  checkedNewArrivals
                                )
                              }
                              onColor="#149AA2"
                              offColor="#F05B83"
                              className="products-status-switch"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Start Product GST Card */}
                      <div className="control-section">
                        <div className="section-header">
                          <h6 className="section-title">Product Taxes</h6>
                        </div>
                        <TextField
                          variant="outlined"
                          type="text"
                          label="GST"
                          value={productGST}
                          onChange={(e) => setProductGST(e.target.value)}
                          fullWidth
                          margin="normal"
                          placeholder="example 18%"
                        />
                        <TextField
                          variant="outlined"
                          type="text"
                          label="SGST"
                          value={productSGST}
                          onChange={(e) => setProductSGST(e.target.value)}
                          fullWidth
                          margin="normal"
                          placeholder="example 6%"
                        />
                        <TextField
                          variant="outlined"
                          type="text"
                          label="CGST"
                          value={productCGST}
                          onChange={(e) => setProductCGST(e.target.value)}
                          fullWidth
                          margin="normal"
                          placeholder="example 6%"
                        />

                        <TextField
                          variant="outlined"
                          type="text"
                          label="CESS"
                          value={productCESS}
                          onChange={(e) => setProductCESS(e.target.value)}
                          fullWidth
                          margin="normal"
                          placeholder="example 6%"
                        />
                        <button
                          className="btn_fill"
                          onClick={() => handleSaveClick("gst")}
                          style={{ marginTop: "8px" }}
                        >
                          Save Tax
                        </button>
                      </div>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </div>
          )}

          {/* QR CODE CARD START */}
          {qrCodeData && qrCodeData.visibilityOnProductDetails === true && (
            <div className="container services_details_bottom_details_parent">
              <div
                className="justify-content-center align-items-center"
                style={{ paddingBottom: "20px" }}
              >
                <div style={{ borderRadius: "15px" }}>
                  <div className="p-2">
                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                      <div className="col-4 col-md-2">
                        <div className="prodct-page-payment-qr-method">
                          <img src="/assets/img/icons/paytm-logo.png" />
                        </div>
                      </div>
                      <div className="col-4 col-md-2">
                        <div className="prodct-page-payment-qr-method">
                          <img src="/assets/img/icons/phonepe-logo.png" />
                        </div>
                      </div>
                      <div className="col-4 col-md-2">
                        <div className="prodct-page-payment-qr-method">
                          <img src="/assets/img/icons/upi-logo.webp" />
                        </div>
                      </div>
                      <div className="col-4 col-md-2">
                        <div className="prodct-page-payment-qr-method">
                          <img src="/assets/img/icons/amazon-pay-logo.webp" />
                        </div>
                      </div>
                      <div className="col-4 col-md-2">
                        <div className="prodct-page-payment-qr-method">
                          <img src="/assets/img/icons/google-pay.webp" />
                        </div>
                      </div>
                      <div className="col-4 col-md-2">
                        <div className="prodct-page-payment-qr-method">
                          <img src="/assets/img/icons/paypal-logo.png" />
                        </div>
                      </div>
                    </div>

                    <hr style={{ marginTop: "0px" }} />

                    <div className="prodct-page-payment-qr-parent row">
                      <div className="prodct-page-payment-qr col-md-5">
                        {user && user.role === "admin" && (
                          <button
                            className="btn_border"
                            onClick={handleAddPhotoClick}
                          >
                            CHANGE QR CODE
                          </button>
                        )}
                        <img
                          src={
                            qrCodeData?.QRCodeImgUrl
                              ? qrCodeData.QRCodeImgUrl.trim() !== ""
                                ? qrCodeData.QRCodeImgUrl // Use the database image if available
                                : "/assets/img/blur-qr.png" // Default image if value is empty
                              : "/assets/img/blur-qr.png"
                          }
                          alt="qr code img"
                        />
                        <br />
                        {qrCodeData &&
                        (qrCodeData.upiId === null ||
                          qrCodeData.upiId === "") ? (
                          <div>
                            {user && user.role === "admin" && (
                              <button
                                onClick={handleEditUpiId}
                                className="btn_fill"
                              >
                                Add UPI
                              </button>
                            )}
                            {isEditingUpiId && (
                              <div>
                                <input
                                  type="text"
                                  value={upiId}
                                  onChange={(e) => setUpiId(e.target.value)}
                                  onBlur={handleSaveUpiId} // Save when the input loses focus
                                />
                                <button onClick={handleSaveUpiId}>Save</button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            {isEditingUpiId ? (
                              <div>
                                <input
                                  type="text"
                                  value={upiId}
                                  onChange={(e) => setUpiId(e.target.value)}
                                />
                                <svg
                                  style={{ cursor: "pointer" }}
                                  onClick={handleSaveUpiId}
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="24px"
                                  viewBox="0 -960 960 960"
                                  width="24px"
                                  fill="var(--click-color)"
                                >
                                  <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                </svg>
                              </div>
                            ) : (
                              <>
                                {user && user.role === "admin" ? (
                                  <h6
                                    onClick={handleEditUpiId}
                                    style={{
                                      fontWeight: "bold",
                                      letterSpacing: "1px",
                                    }}
                                  >
                                    UPI ID : {qrCodeData.upiId}
                                  </h6>
                                ) : (
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      letterSpacing: "1px",
                                    }}
                                  >
                                    UPI ID : {qrCodeData.upiId}
                                  </h6>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="d-flex justify-content-center flex-column col-md-7 mt-4">
                        <MDBCardText className="text-muted">
                          <h3 className="fw-bold mb-3">
                            Accept Payments Easily with QR Scanning!
                          </h3>
                        </MDBCardText>
                        <ul className="list-unstyled">
                          <li className="mb-2">
                            <strong>Quick & Hassle-Free:</strong> Secure QR code
                            payment system for seamless transactions.
                          </li>
                          <li className="mb-2">
                            🔹 <strong>Simple Process:</strong>
                            <ul className="ps-3 mt-1">
                              <li>
                                📌 Scan the QR code using any{" "}
                                <strong>UPI-supported app</strong>.
                              </li>
                              <li>💰 Enter the amount.</li>
                              <li>⚡ Confirm the transaction instantly.</li>
                            </ul>
                          </li>
                          <li className="mb-2">
                            🔹 <strong>Key Benefits:</strong>
                            <ul className="ps-3 mt-1">
                              <li>⚡Instant transactions.</li>
                              <li>🔒 Safe and encrypted payments.</li>
                              <li>📱 Works with all major UPI apps.</li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* QR CODE CARD END */}

          <div className="container services_details_bottom_details_parent">
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs value={selectedTab} aria-label="details tabs">
                {productDetailsVisibility &&
                  productDetailsVisibility.productFeatures && (
                    <Tab
                      label="Features"
                      value="features"
                      onClick={() => setSelectedTab("features")}
                    />
                  )}
                {productDetailsVisibility &&
                  productDetailsVisibility.productDescription && (
                    <Tab
                      label="Details"
                      value="details"
                      onClick={() => setSelectedTab("details")}
                    />
                  )}
              </Tabs>
            </Box>

            {selectedTab === "details" && (
              <MDBRow className="justify-content-center align-items-center">
                <MDBCard style={{ borderRadius: "15px" }}>
                  <MDBCardBody className="p-4">
                    <MDBTypography tag="h3">
                      <strong style={{ color: "var(--heading-color)" }}>
                        Details
                      </strong>
                    </MDBTypography>
                    <hr className="my-4" />
                    <div className="d-flex justify-content-start align-items-center">
                      <MDBCardText className="mb-0">
                        <MDBCardText className="text-muted">
                          {isEditingDescription ? (
                            <div>
                              <div>
                                <TextEditor
                                  initialDescription={editedDescription}
                                  documentId={productId}
                                  docFieldName="description"
                                  collectionName="products"
                                  onSave={() => handleSaveClick("description")}
                                  onCancel={() =>
                                    handleCancelClick("description")
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: document.description.toString("html"),
                                }}
                              ></p>
                              {!isEditingDescription &&
                                user &&
                                user.role == "admin" && (
                                  <FaEdit
                                    style={{
                                      fontSize: 20,
                                      cursor: "pointer",
                                      marginLeft: "10px",
                                      color: "var(--click-color)",
                                    }}
                                    onClick={() =>
                                      handleEditClick("description")
                                    }
                                  />
                                )}
                            </div>
                          )}
                        </MDBCardText>
                      </MDBCardText>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            )}

            {selectedTab === "features" && (
              <MDBRow className="justify-content-center align-items-center">
                <MDBCard style={{ borderRadius: "15px" }}>
                  <MDBCardBody className="p-4">
                    <MDBTypography tag="h3">
                      <strong style={{ color: "var(--heading-color)" }}>
                        Features
                      </strong>
                    </MDBTypography>
                    <hr className="my-4" />
                    <div className="d-flex justify-content-start align-items-center">
                      <MDBCardText className="mb-0">
                        <MDBCardText className="text-muted">
                          {isEditingFeatures ? (
                            <div>
                              <TextEditor
                                initialDescription={
                                  (document && document.features) || ""
                                }
                                documentId={productId}
                                docFieldName="features"
                                collectionName="products"
                                onSave={() => {
                                  setIsEditingFeatures(false);
                                  setSnackbarMessage(
                                    "Features updated successfully"
                                  );
                                  setSnackbarOpen(true);
                                }}
                                onCancel={() => {
                                  setIsEditingFeatures(false);
                                  setEditedFeatures(document.features);
                                }}
                              />
                            </div>
                          ) : (
                            <div className="d-flex align-items-center">
                              {document && document.features ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: document.features,
                                  }}
                                />
                              ) : (
                                <p>Features not available</p>
                              )}
                              {!isEditingFeatures &&
                                user &&
                                user.role == "admin" && (
                                  <FaEdit
                                    style={{
                                      fontSize: 20,
                                      cursor: "pointer",
                                      marginLeft: "10px",
                                      color: "var(--click-color)",
                                    }}
                                    onClick={() => setIsEditingFeatures(true)}
                                  />
                                )}
                            </div>
                          )}
                        </MDBCardText>
                      </MDBCardText>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            )}
          </div>

          {/* Location Update Popup */}
          <Modal
            open={isLocationPopupOpen}
            onClose={() => setIsLocationPopupOpen(false)}
            aria-labelledby="location-modal-title"
          >
            <Box sx={modalStyle}>
              <h2 id="location-modal-title">Update Product Location</h2>
              <TextField
                label="Google Maps Embed URL"
                fullWidth
                value={locationLink}
                onChange={(e) => setLocationLink(e.target.value)}
                margin="normal"
                placeholder="Paste Google Maps embed URL here"
              />
              <div className="modal-actions">
                <Button
                  variant="outlined"
                  onClick={() => setIsLocationPopupOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    try {
                      await updateDocument(productId, {
                        productLocation: locationLink,
                      });
                      setIsLocationPopupOpen(false);
                      setSnackbarMessage("Location updated successfully");
                      setSnackbarOpen(true);
                    } catch (error) {
                      console.error("Error updating location:", error);
                      setSnackbarMessage("Error updating location");
                      setSnackbarOpen(true);
                    }
                  }}
                >
                  Save Location
                </Button>
              </div>
            </Box>
          </Modal>

          {/* Only show location section if productLocation exists and is not empty */}
          {document?.productLocation &&
            document.productLocation.trim() !== "" && (
              <section className="form_sec">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="map_top_heading">Product Location</h2>
                  {user && user.role === "admin" && (
                    <button
                      className="btn_fill"
                      onClick={() => {
                        setIsLocationPopupOpen(true);
                        setLocationLink(document?.productLocation || "");
                      }}
                      style={{ marginBottom: "10px" }}
                    >
                      Update Location
                    </button>
                  )}
                </div>
                <iframe
                  src={document && document.productLocation}
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                ></iframe>
              </section>
            )}
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: "120%",
            backgroundColor: "white",
            border: "1px solid black",
          }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <CorporateTwoClients
        category="partners"
        pageName="contact"
        section="partners"
        addMoreVideosButton={false}
        addMoreImagesButton={true}
        addMoreTextContentButton={false}
      />

      {/* Add the Copy Modal */}
      <Modal
        open={isCopyModalOpen}
        onClose={() => {
          setIsCopyModalOpen(false);
          resetCopyForm();
        }}
        aria-labelledby="copy-modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="copy-modal-title">Copy Product</h2>
          <div className="copy-modal-content">
            <div className="role-selection">
              <p>Select Role:</p>
              <div className="radio-group">
                {["dealer", "retailer", "customer"].map((role) => (
                  <label key={role} className="radio-label">
                    <input
                      type="radio"
                      name="copyRole"
                      value={role}
                      checked={selectedRole === role}
                      onChange={handleRoleChange}
                    />
                    <span className="radio-text">
                      {role.charAt(0).toUpperCase() + role.slice(1)}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {selectedRole && (
              <div className="copy-form">
                <TextField
                  label="Product Name"
                  name="name"
                  value={copyProductForm && copyProductForm.name}
                  onChange={handleCopyFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="Price"
                  name="price"
                  type="number"
                  value={copyProductForm && copyProductForm.price}
                  onChange={handleCopyFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="Discount"
                  name="discount"
                  value={copyProductForm && copyProductForm.discount}
                  onChange={handleCopyFormChange}
                  fullWidth
                  margin="normal"
                  placeholder="e.g., 10%"
                />
              </div>
            )}

            <div className="modal-actions">
              <Button
                variant="outlined"
                onClick={() => {
                  setIsCopyModalOpen(false);
                  resetCopyForm();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleCopyProduct}
                disabled={
                  !selectedRole ||
                  !copyProductForm.name ||
                  !copyProductForm.price
                }
              >
                Create Copy
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={isQuantityModalOpen}
        onClose={() => setIsQuantityModalOpen(false)}
        aria-labelledby="quantity-modal-title"
      >
        <Box sx={modalStyle}>
          <h2 id="quantity-modal-title">Quantity Settings</h2>
          <div className="quantity-modal-content">
            <TextField
              label="Maximum Order Quantity"
              name="maxQuantity"
              type="number"
              value={quantityForm && quantityForm.maxQuantity}
              onChange={handleQuantityFormChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Minimum Order Quantity"
              name="minQuantity"
              type="number"
              value={quantityForm && quantityForm.minQuantity}
              onChange={handleQuantityFormChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Available Stock"
              name="stock"
              type="number"
              value={quantityForm && quantityForm.stock}
              onChange={handleQuantityFormChange}
              fullWidth
              margin="normal"
            />
          </div>
          <div className="modal-actions">
            <Button
              variant="outlined"
              onClick={() => setIsQuantityModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveQuantity}
              disabled={
                !quantityForm.maxQuantity ||
                !quantityForm.minQuantity ||
                !quantityForm.stock
              }
            >
              Save Settings
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ProductDetails;
